<template>
    
</template>

<script>
    export default {
        name: "Prescriptions"
    }
</script>

<style scoped>

</style>